import { render, staticRenderFns } from "./NewOdontograma.vue?vue&type=template&id=2dcbad2e&scoped=true&"
import script from "./NewOdontograma.vue?vue&type=script&lang=js&"
export * from "./NewOdontograma.vue?vue&type=script&lang=js&"
import style0 from "./NewOdontograma.vue?vue&type=style&index=0&id=2dcbad2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcbad2e",
  null
  
)

export default component.exports